module.exports = __webpack_public_path__ + "account/assets/filter-filled.881fd06f.svg";